<div ngbDropdown class="d-inline-block" >
  <button  type="button" ngbDropdownToggle class="btn btn-outline-secondary">
    <!-- <img [src]="getLang(current())?.icon" width="30"  alt=""> -->
    {{ getLang(current())?.label }}
</button>

  <div ngbDropdownMenu>
    <button
      type="button" 
      ngbDropdownItem
      *ngFor="let l of languages"
      [class.active]="l.code === current()"
      (click)="changeLang(l.code)">
      {{ l.name }}
      <!-- <img [src]="l.icon" width="30" class="me-2" alt="" /> {{ l.label }} -->
    </button>
  </div>
</div>
